export default __webpack_public_path__ + "static/travelworkz-a6f538134c7e4cab813712964d0fdb84.png";